module.exports = __webpack_public_path__ + "static/media/home.612679a9.png";